export default {
    days: {
        monday: {
            active: true,
            errors: false,
            from: {
                hh: '07',
                mm: '30'
            },
            to: {
                hh: '17',
                mm: '30'
            }
        },
        tuesday: {
            active: true,
            errors: false,
            from: {
                hh: '07',
                mm: '30'
            },
            to: {
                hh: '17',
                mm: '30'
            }
        },
        wednesday: {
            active: true,
            errors: false,
            from: {
                hh: '07',
                mm: '30'
            },
            to: {
                hh: '17',
                mm: '30'
            }
        },
        thursday: {
            active: true,
            errors: false,
            from: {
                hh: '07',
                mm: '30'
            },
            to: {
                hh: '17',
                mm: '30'
            }
        },
        friday: {
            active: true,
            errors: false,
            from: {
                hh: '07',
                mm: '30'
            },
            to: {
                hh: '12',
                mm: '30'
            }
        },
        saturday: {
            active: false,
            errors: false,
            from: {
                hh: '07',
                mm: '30'
            },
            to: {
                hh: '17',
                mm: '30'
            }
        },
        sunday: {
            active: false,
            errors: false,
            from: {
                hh: '07',
                mm: '30'
            },
            to: {
                hh: '17',
                mm: '30'
            }
        }
    },
    startTime: {
        hh: '07',
        mm: '30'
    },
    endTime: {
        hh: '17',
        mm: '30'
    },
}
